<template>
  <div>
    <h5>Начисления по Задаче</h5>

    <!-- <b-table striped hover :items="items"></b-table> -->
    <tableOperations :items="items"
      @update-operations-table="getItems( operationDefault.task )"
    />
    <b-button @click="getItems(operationDefault.task)">Обновить данные</b-button>

    <h5>Добавить начисление по задаче</h5>
    <div><addOperation
          v-if="operationDefault.dataReady"
          v-bind:operationDefault="operationDefault"
          mode="add"
          @update-operations-table="getItems( operationDefault.task )"
     /></div>
  </div>
</template>

<script>
import addOperation from '../components/addOperations.vue'
import tableOperations from '../components/tableOperations.vue'
export default {
  components: {
    addOperation,
    tableOperations
  },
    data() {
      return {
        placementInfo: 'placementInfo',
        operationDefault: null,
        operationDefault: {
          task: null,
          deal: null,
          user: null,
          contact: null,
          company: null,
          dataReady: false
        },
        items: [],
      }
  },
  async created() {
      this.placementInfo = BX24.placement.info()
      this.operationDefault.task = this.placementInfo.options.taskId

      // Это вытаскивает через поле сущностей CRM с которыми связана задача
      let result = await this.$store.dispatch ( 'getDealAndCompanyByTask', this.operationDefault.task, { root: true } );
      if ( result ) {
        this.operationDefault.deal = result[0] || null
        this.operationDefault.company = result[1] || null
      }

      this.operationDefault.dataReady = true

      this.getItems( this.operationDefault.task )
  },
  methods: {
    getItems ( taskId ) {
      // Фильтр на основе текущего места вызова, фильтрация по property
      let payload = {
            ENTITY: 'accrual',
            FILTER: {
              PROPERTY_TASK: taskId
            },
      }
      this.$store.dispatch( 'getItems', payload, { root: true } )
      .then (result => {
          // console.dir(result);
          this.items = []
          result.map ( item => {
              this.items.push (
              {
                  'status': item.PROPERTY_VALUES.status,
                  'user': item.PROPERTY_VALUES.user,
                  'reference': item.PROPERTY_VALUES.reference,
                  'amount': item.PROPERTY_VALUES.amount,
                  'typeOfPayment': item.PROPERTY_VALUES.typeOfPayment,
                  'dataSort': item.PROPERTY_VALUES.dataSort,
                  'task': item.PROPERTY_VALUES.task,
                  'deal': item.PROPERTY_VALUES.deal,
                  'company': item.PROPERTY_VALUES.company,
                  'contact': item.PROPERTY_VALUES.contact,
                  'id': item.ID
              })

          })
      })
    }
  },
}
</script>

// ACTIVE: "Y"
// CODE: null
// CREATED_BY: "1"
// DATE_ACTIVE_FROM: "2022-01-22T20:00:00+03:00"
// DATE_ACTIVE_TO: ""
// DATE_CREATE: "2022-01-20T12:23:32+03:00"
// DETAIL_PICTURE: null
// DETAIL_TEXT: null
// ENTITY: "accrual"
// ID: "58891"
// MODIFIED_BY: "1"
// NAME: "dgghd"
// PREVIEW_PICTURE: null
// PREVIEW_TEXT: null
// PROPERTY_VALUES: {payer: '', reference: 'dgghd', amount: '34', dataSort: '2022-01-23', accountId: '', …}
// SECTION: null
// SORT: "500"
// TIMESTAMP_X: "2022-01-20T12:23:32+03:00"